import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import ReactEcharts from 'echarts-for-react';
import clsx from 'clsx';
import i18n from '@pureartisan/simple-i18n';
import echarts from 'echarts/lib/echarts';
import { FaExternalLinkSquareAlt } from 'react-icons/fa';
import { CPAL_FEEDER_TIP_ITEMS } from './../../../../constants/metrics';
import useStore from './../store';
import { getRoundedValue, toTitleCase, getFeederAverage, getFeederLabel, getSchoolSet } from './../utils';

var FeederLegendContent = function FeederLegendContent(_ref) {
  var props = _extends({}, _ref); // Generic state updates for store.
  // Accepts an object of values to update.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  }); // Currently active (hovered) feeder
  // Stores the SLN of the feeder

  var activeFeeder = useStore(function (state) {
    return state.activeFeeder;
  });
  var feederLocked = useStore(function (state) {
    return state.feederLocked;
  });
  var breakpoint = useStore(function (state) {
    return state.breakpoint;
  }); // Track events for access of school page.

  var eventSchoolPage = useStore(function (state) {
    return state.eventSchoolPage;
  }); // Track event when a school is accessed.

  var handleSchoolAccess = function handleSchoolAccess(e) {
    var id = String(e.currentTarget.id).replace('school_', '');
    setStoreValues({
      accessedSchool: id,
      eventSchoolPage: eventSchoolPage + 1
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", null, i18n.translate('UI_FEEDER_TITLE_FEEDER_CHART')), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("h3", null, getFeederLabel(activeFeeder) + ' ' + toTitleCase(i18n.translate('TERM_PLURAL', {
    term: i18n.translate('TERM_SCHOOL')
  }))), /*#__PURE__*/React.createElement("div", {
    className: "feeder-legend-metrics",
    "aria-live": "assertive"
  }, /*#__PURE__*/React.createElement("h4", null, toTitleCase(i18n.translate('TERM_PLURAL', {
    term: i18n.translate("TERM_INDEX_AVERAGE")
  }))), CPAL_FEEDER_TIP_ITEMS.map(function (el) {
    return /*#__PURE__*/React.createElement("span", {
      id: 'index_avg_' + el.id,
      key: 'index_avg_' + el.id,
      className: "feeder-index"
    }, i18n.translate(el.title), /*#__PURE__*/React.createElement("span", {
      className: "index-value"
    }, '   ', getRoundedValue(getFeederAverage(el.id, getSchoolSet(activeFeeder)), 0)));
  }), /*#__PURE__*/React.createElement("i", null, i18n.translate('UI_FEEDER_TOOLTIP_INDEX_DESC'))), /*#__PURE__*/React.createElement("div", {
    className: "feeder-legend-schools"
  }, /*#__PURE__*/React.createElement("h4", null, toTitleCase(i18n.translate('TERM_PLURAL', {
    term: i18n.translate('TERM_SCHOOL')
  }))), getSchoolSet(activeFeeder).map(function (el) {
    return /*#__PURE__*/React.createElement("a", {
      href: '/schools/' + el.TEA + '/',
      target: "_blank",
      rel: "noreferrer",
      className: "school",
      id: 'school_' + el.TEA,
      key: 'school_' + el.TEA,
      onClick: function onClick(e) {
        return handleSchoolAccess(e);
      }
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FaExternalLinkSquareAlt, null), " ", el.SCHOOLNAME));
  })));
};

export default FeederLegendContent;